import * as React from 'react';
import styled from 'styled-components';
import { Button, SearchIcon } from '@shortlyster/ui-kit';
import { Form, SelectSingle } from '@shortlyster/forms-kit';
import { TextInput, IconBox } from '@compono/ui';
import { MagnifySearchSolidIcon } from '@compono/ui-icons';

const StyledForm = styled(Form as any)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1.8rem;

  & > div:first-child {
    width: 40%;
    margin-right: 1rem;
  }

  & label {
    display: none;
  }

  & input {
    border: none;
    border-radius: 6px;
  }
`;

const StyledButton = styled(Button)`
  border-radius: 6px;
  height: 42px;
  width: 44px;
  padding: 3px 0 0 3px;
`;

type Option = {
  label: string;
  value: string;
};

interface Props {
  onSubmit: (props: any) => any;
  onChange?: (props: any) => any;
  search?: string;
  options?: Option[];
  defaultValueInOption?: string;
  placeholder?: string;
}

const SearchBar = ({
  onChange,
  onSubmit,
  search,
  options,
  defaultValueInOption,
  placeholder,
}: Props) => (
  <StyledForm onSubmit={onSubmit}>
    <TextInput
      name="searchInput"
      placeholder={placeholder}
      defaultValue={search}
      type="text"
      size="md"
      onChange={onChange}
      iconLeft={
        <IconBox
          position="left"
          icon={MagnifySearchSolidIcon}
          themeKey="inputIcons"
          title="Search"
          size="md"
        />
      }
    />
    {options ? (
      // @ts-expect-error React 17/18 type mismatch from @shortlyster/forms-kit
      <SelectSingle
        name="statusOption"
        options={options}
        defaultValue={defaultValueInOption}
      />
    ) : (
      <> </>
    )}
    <StyledButton icon={SearchIcon} type="submit" />
  </StyledForm>
);

export default SearchBar;
